(ns ycweb.app.blitz.packing.runner
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.app.dashboard.presence :as p]
   [clojure.set :as set]))

(def steps
  (forms/setup-steps
    [{:key :ordersize :title "Select packing order size"}
     {:key :scanshelf :title "Scan shelf and grab items"}
     {:key :waitforpacker :title "Wait for available packer"}
     {:key :scandesk :title "Scan desk and drop off items"}]))

(defn slat-colour [colour]
  (case colour
    "red"
    [:red :red-bg]

    "blue"
    [:blue :blue-bg]

    "green"
    [:green :green-bg]

    "red-green"
    [:red-green :neutral-bg]

    "grey"
    [:neutral :neutral-bg]

    [:neutral :neutral-bg]))

(defn transform-user-data [{:presence/keys [user]}]
  {:public-id (get-in user [:ent/image :doc/public-id])
   :name (:ent/display-name user)})

(rum/defc packer-image [packer]
  (let [status
        (case (get-in packer [:presence/context :packing-desk/status :db/ident])
          :packing-desk.status/open :active
          :packing-desk.status/paused :is-inactive
          :packing-desk.status/closed :removed)]
    [:div.picking-slat__user-image
     (p/user-image-block (:presence/user packer) status {:h 34 :w 34})]))

(rum/defc packing-type-slat < rum/reactive
  [{:keys [displayname colour alloc-count packers]} {:keys [on-click]}]
  (let [[slat-color slat-bg-color] (slat-colour colour)]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color slat-bg-color]) :on-click on-click}
      [:div.picking-slat__graphic-wrapper
       [:span.picking-slat__icon-wrapper
        [:span.picking-slat__size-text
         (str/upper-case (first displayname))]]]
      [:div.picking-slat__info
       [:h3.pickin-slat__title (str displayname " (Orders: " alloc-count ", Packers: " (count packers) ")")]
       [:div.picking-slat__user-wrapper
        (map #(packer-image %) packers)]]]]))

(defn group-orders [orders]
  (let [grouped-orders (group-by #(get-in % [:size :name]) orders)]
    {:large-orders (get grouped-orders "Large")
     :medium-orders (get grouped-orders "Medium")
     :small-orders (get grouped-orders "Small")}))

(defn group-packdesks [packers]
  (let [grouped-packers
        (group-by
          #(get-in %
             [:presence/context :packing-desk/packing-group :ent/display-name])
          packers)]
    {:large-packdesks (get grouped-packers "Large")
     :medium-packdesks (get grouped-packers "Medium")
     :small-packdesks (get grouped-packers "Small")}))

(rum/defc packer-running-size-select < rum/reactive [app-atom]
  (let [packer-running-atom (rum/cursor app-atom :packer-running)
        orders (cmn/curact packer-running-atom :orders)
        packers (cmn/curact packer-running-atom :packers)

        {:keys [small-orders medium-orders large-orders]} (group-orders orders)
        {:keys [small-packdesks medium-packdesks large-packdesks]} (group-packdesks packers)

        total-orders (count orders)]
    (w/wrapper app-atom "Packer Running"
      {:steps steps :step :ordersize}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Select Packing Order Size to Run For"
         [:span.heading__subtext
          "Total orders: "
          [:b total-orders]]]]
       [:div.slats
        (packing-type-slat
          {:displayname "Small"
           :alloc-count (count small-orders)
           :packers small-packdesks
           :colour "red"}
          {:on-click
           #(cond
              (empty? small-orders)
              (toaster/open-toast app-atom :error "No Small Orders" {})

              :else
              (grid/dispatch-action app-atom :packer-running/claim-order {:packing-area "Small"}))})
        (packing-type-slat
          {:displayname "Medium"
           :alloc-count (count medium-orders)
           :packers medium-packdesks
           :colour "green"}
          {:on-click
           #(cond
              (empty? medium-orders)
              (toaster/open-toast app-atom :error "No Medium Orders" {})

              :else
              (grid/dispatch-action app-atom :packer-running/claim-order {:packing-area "Medium"}))})
        (packing-type-slat
          {:displayname "Large"
           :alloc-count (count large-orders)
           :packers large-packdesks
           :colour "blue"}
          {:on-click
           #(cond
              (empty? large-orders)
              (toaster/open-toast app-atom :error "No Large Orders" {})

              :else
              (grid/dispatch-action app-atom :packer-running/claim-order {:packing-area "Large"}))})]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :main-menu)
         :right-plain true}))))

(defmethod grid/action :packer-running/claim-order [app-atom config _]
  (let [packer-running-atom (rum/cursor app-atom :packer-running)]
    (toaster/open-subtle-progress app-atom)
    (swap! packer-running-atom assoc :packing-area (:packing-area config))
    (comms/send :packer-running/find-next-order config)))

(defmethod comms/receive :packer-running/find-next-order [app-atom {:keys [claimed-order]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :packer-running
    (fn [packer-running]
      (->
        packer-running
        (assoc :selected-order claimed-order)
        (dissoc :scanned-shelves))))
  (t/transition-next app-atom :packer-running/scan-shelf))

(defmethod grid/action :packer-running.scan-shelf/scan [app-atom {:keys [scan]} _]
  (let [packer-running-atom (rum/cursor app-atom :packer-running)
        scanned-shelves (cmn/curact packer-running-atom :scanned-shelves)
        current-order (cmn/curact packer-running-atom :selected-order)
        packing-area (cmn/curact packer-running-atom :packing-area)
        already-scanned? (contains? scanned-shelves scan)
        order-locations (set (map :barcode (:locations current-order)))
        shelves-to-scan (set/difference order-locations scanned-shelves)]


    (comms/send :packer-running/shelf-scanned
      {:order-id (:id current-order)
       :shelf-barcode scan})

    (cond
      already-scanned?
      (toaster/open-toast app-atom :error "Shelf Already Scanned" {})

      (not (contains? shelves-to-scan scan))
      (toaster/open-toast app-atom :error "Incorrect Shelf Scanned" {})

      :else
      (let [updated-scanned-shelves (merge (or scanned-shelves #{}) scan)
            updated-shelves-to-scan (set/difference order-locations updated-scanned-shelves)]
        (swap! packer-running-atom assoc :scanned-shelves updated-scanned-shelves)
        (when (empty? updated-shelves-to-scan)
          (grid/dispatch-action app-atom :packer-running/find-packer
            {:packing-area packing-area}))))))

(defmethod grid/action :packer-running/find-packer [app-atom {:keys [packing-area packdesk-uuid]}]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom update :packer-running dissoc :available-packer)
  (comms/send :packer-running/find-available-packer
    {:packing-area packing-area
     :packdesk-uuid packdesk-uuid}))

(defmethod comms/receive :packer-running/find-available-packer [app-atom {:keys [available-packer]}]
  (toaster/close-subtle-progress app-atom)
  (let [packer-running-atom (rum/cursor app-atom :packer-running)]
    (swap! packer-running-atom assoc :available-packer available-packer)
    (cond
      available-packer
      (t/transition-next app-atom :packer-running/scan-desk)

      :else
      (do
        (toaster/open-toast app-atom :error "No packer available" {:closetime 2000})
        (t/transition-next app-atom :packer-running/wait-for-packer)))))

(defmethod flow/render-screen :packer-running/areas [app-atom _]
  (packer-running-size-select app-atom))

(defmethod grid/action :packer-running/areas [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :packer-running/order-list {:quickship? false}))

(defmethod comms/receive :packer-running/order-list
  [app-atom {:keys [orders packers quickship?] :as c}]
  (toaster/close-subtle-progress app-atom)
  (p/open-inline-node app-atom
    {:context/ident :packing/packer-running})
  (swap! app-atom update :packer-running assoc
    :quickship? quickship?
    :uuid (:uuid c)
    :orders orders
    :packers packers)
  (t/transition-next app-atom :packer-running/areas))

;; ================== Update packers Broadcast ===========================
(defmethod comms/receive :packer-running/update-packers [app-atom resp]
  (let [packer-running-atom (rum/cursor app-atom :packer-running)]
    (swap! packer-running-atom update :packers
      (fn [packers]
        (let [idx-fn #(get-in % [:presence/context :ent/uuid])
              idx-packers (u/index-by idx-fn packers)
              updated-packers
              (reduce
                (fn [acc packdesk]
                  (let [packdesk-uuid (get-in packdesk [:presence/context :ent/uuid])
                        packdesk-status (get-in packdesk [:presence/context :packing-desk/status :db/ident])
                        existing-packdesk (get idx-packers packdesk-uuid)]
                    (cond
                      (and
                        existing-packdesk
                        (= packdesk-status :packing-desk.status/closed))
                      (dissoc acc packdesk-uuid)

                      :else
                      (assoc acc packdesk-uuid packdesk))))
                idx-packers (:packers resp))]
          (vals updated-packers))))))

(rum/defc scan-shelf < rum/reactive [app-atom]
  (let [running-atom (rum/cursor app-atom :packer-running)
        order (cmn/curact running-atom :selected-order)
        idx-order-locations (u/index-by :barcode (:locations order))
        order-location-barcodes (set (map :barcode (:locations order)))
        scanned-shelves (cmn/curact running-atom :scanned-shelves)
        remaining-shelves (set/difference order-location-barcodes scanned-shelves)
        first-shelf-barcode (first remaining-shelves)
        shelf-count (- (count order-location-barcodes) (count remaining-shelves))
        first-location (get idx-order-locations first-shelf-barcode)]
    (w/wrapper app-atom "Packer Running"
      {:steps steps :step :scanshelf}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan " (str/lower-case (get-in order [:size :name])) " shelf:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b first-shelf-barcode]
         [:span.heading__subtext
          "Order: " [:b (:orderno order)]]]]
       [:div
        [:i.u-block-center
         {:class
          (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]
      [[:aside.page-body__footer.u-margin-top-16
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         [:b (if (zero? shelf-count) 1 (+ shelf-count 1)) " of " (count (:locations order)) " location" (when (> (count (:locations order)) 1) "s") ":"]]
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         (str (:qty first-location) " items on this shelf")]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Shelf"
         :right-plain true}))))

(defmethod flow/barcode-dispatch-screen :packer-running/scan-shelf [_ app-atom scan]
  (grid/dispatch-action app-atom :packer-running.scan-shelf/scan {:scan scan}))

(defmethod flow/render-screen :packer-running/scan-shelf [app-atom _]
  (scan-shelf app-atom))

(defmethod grid/action :packer-runner/unclaim-order [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (let [packer-running-atom (rum/cursor app-atom :packer-running)
        selected-order (cmn/curact packer-running-atom :selected-order)]
    (comms/send :packer-running/release-current-order
      {:order-uuid (:uuid selected-order)
       :picking-order-uuid (:po-uuid selected-order)})))

(defmethod comms/receive :packer-running/release-current-order [app-atom e]
  (cond
    (:success e)
    (do
      (toaster/open-toast app-atom :success "Fetching latest orders" {:closetime 2000})
      (comms/send :packer-running/order-list {:quickship? false}))

    :else
    (do
      (toaster/close-subtle-progress app-atom)
      (toaster/open-toast app-atom :error "An error occurred while unclaiming the order" {:closetime 2000}))))

(rum/defc runner-wait < rum/reactive [app-atom]
  (let [packing-area (cmn/curact app-atom [:packer-running :packing-area])]
    (w/wrapper app-atom "Packer Running"
      {:steps steps :step :waitforpacker
       :modal-fn
       #(grid/menu-modal app-atom
          {:items
           [{:label "Unclaim & Stop"
             :action :packer-runner/unclaim-order
             :style
             {:full true :large true :negative true
              :text-default true :icon-left :delete :icon-class :3-2}}
            {:label "Close"
             :action :picking/cancel-modal
             :style
             {:full true :large true :text-link true :on-dark true}}]})}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "No Packer Available"
         [:span.heading__subtext
          "Please wait for a moment and refresh"]]]
       [:div.section
        [:i.u-block-center
         {:class
          (u/bem :icon [:block :enormous :light-force :clock :2-1])}]
        [:div.u-text-center.u-margin-top-32
         (buttons/button "Refresh"
           #(grid/dispatch-action app-atom :packer-running/find-packer
              {:packing-area packing-area})
           {:secondary true
            :raised true
            :large true
            :full true
            :icon-left :refresh})]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true})))
  )

(defmethod flow/render-screen :packer-running/wait-for-packer [app-atom _]
  (runner-wait app-atom))

(rum/defc scan-desk < rum/reactive [app-atom]
  (let [packer-running-atom (rum/cursor app-atom :packer-running)
        packing-area (cmn/curact packer-running-atom :packing-area)
        selected-order (cmn/curact packer-running-atom :selected-order)
        total-qty (reduce #(+ %1 (:qty %2)) 0 (:locations selected-order))

        {:presence/keys [user context]} (cmn/curact packer-running-atom :available-packer)
        {:packing-desk/keys [location]} context]
    (w/wrapper app-atom "Packer Running"
      {:steps steps :step :scandesk
       :modal-fn
       #(grid/menu-modal app-atom
          {:items
           [{:label "Request different pack desk"
             :action :packer-running/find-packer
             :config
             {:packing-area packing-area
              :packdesk-uuid (:ent/uuid context)}
             :style
             {:full true :large true
              :icon-left :refresh :icon-class :3-2}}
            {:label "Unclaim & Stop"
             :action :packer-runner/unclaim-order
             :style
             {:full true :large true :negative true
              :text-default true :icon-left :delete :icon-class :3-2}}
            {:label "Close"
             :action :picking/cancel-modal
             :style
             {:full true :large true :text-link true :on-dark true}}]})}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan desk:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b (str (:ent/display-name location) " | " (:ent/display-name user))]

         [:span.heading__subtext
          "Order: " [:b  (:orderno selected-order)]]]]
       [:div
        [:i.u-block-center
         {:class
          (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]
      [[:aside.page-body__footer.u-margin-top-16
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         (cond
           (= total-qty 1)
           "1 item to drop off"

           (> total-qty 1)
           (str total-qty " items to drop off"))]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Desk"
         :right-plain true}))))

(defmethod flow/render-screen :packer-running/scan-desk [app-atom _]
  (scan-desk app-atom))

(defmethod flow/barcode-dispatch-screen :packer-running/scan-desk [_ app-atom scan]
  (grid/dispatch-action app-atom :packer-running.scan-desk/scan {:scan scan}))

(defmethod grid/action :packer-running.scan-desk/scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [packer-running-atom (rum/cursor app-atom :packer-running)
        selected-order (cmn/curact packer-running-atom :selected-order)

        {:presence/keys [user context]} (cmn/curact packer-running-atom :available-packer)
        {:packing-desk/keys [location]} context]

    (cond
      (= (:ent/display-name location) scan)
      (comms/send :packer-running/handover-order
        {:user-uuid (:ent/uuid user)
         :packdesk-uuid (:ent/uuid context)
         :picking-order-uuid (:po-uuid selected-order)})

      :else
      (toaster/open-toast app-atom :error "Invalid location" {:closetime 2000}))))

(defmethod comms/receive :packer-running/handover-order [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :packer-running/areas))